var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 2a3 3 0 00-3 3v1H14a1 1 0 00-1 1v5a1 1 0 001 1h7a1 1 0 001-1V7a1 1 0 00-1-1h-.5V5a3 3 0 00-3-3zm0 1.5A1.5 1.5 0 0016 5v1h3V5a1.5 1.5 0 00-1.5-1.5zm-3 8v-4h6v4h-6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.955 4c1.422 0 2.625.516 3.545 1.36v2.398a.75.75 0 01-.16-.198C10.633 6.294 9.47 5.5 7.955 5.5 5.465 5.5 3.5 7.399 3.5 10.206c0 1.677.728 3.402 2.135 5.131 1.405 1.729 3.456 3.418 6.007 5 .086.05.18.098.264.13.038.015.069.024.09.03a.81.81 0 00.095-.03c.084-.034.175-.08.248-.125l.005-.003c2.553-1.582 4.608-3.273 6.017-5.002.227-.28.437-.558.629-.837h1.772a13.396 13.396 0 01-1.238 1.784c-1.548 1.9-3.748 3.692-6.388 5.329l.002-.002-.4-.635.396.638.002-.002a3 3 0 01-.507.254 1.817 1.817 0 01-.634.134c-.24 0-.468-.071-.632-.134a3.288 3.288 0 01-.499-.247l-.007-.005c-2.642-1.637-4.84-3.43-6.386-5.33C2.925 14.384 2 12.334 2 10.206 2 6.613 4.594 4 7.955 4z",
    fill: "currentColor"
  })));
}
export default SvgHeartLock;